import { PaymentMethod } from '../enums';

export function getPaymentMethodsSetToDisable(): PaymentMethod[] {
    //@ts-ignore
    const map: Record<PaymentMethod, boolean> = window?.WFP_CONFIG?.DISABLE_PAYMENT_METHODS || {};
    const entries = Object.entries(map) as Array<[PaymentMethod, boolean]>;
    return entries.filter(([k, b]) => b).map(([k, b]) => k);
}
